module.exports = __webpack_public_path__ + "assets/img/about_en.34384f63.jpg";